'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {};

exports.default = function (props) {
  var customStyles = Object.assign({}, defaultStyles, props.style);
  return _react2.default.createElement('svg', {
    viewBox: '0 0 332.1 39.7',
    className: props.className ? props.className + ' icon icon-logo-text' : 'icon icon-logo-text',
    style: customStyles
  }, _react2.default.createElement('path', {
    fill: '#30CADA',
    d: 'M0.1,39V0.7h26.9v8.8H11.3v7.3h14.2v8.4H11.3v13.5H0.1V39z'
  }), _react2.default.createElement('path', {
    fill: '#30CADA',
    d: 'M39.5,39V0.7h11.3v38.4L39.5,39L39.5,39z'
  }), _react2.default.createElement('path', {
    fill: '#30CADA',
    d: 'M65,39V0.7h8.7l14.8,19.9h0.3V0.7h10.6v38.4h-8.7L75.7,19h-0.3v20.2L65,39L65,39z'
  }), _react2.default.createElement('path', {
    fill: '#FFFFFF',
    d: 'M113.6,39V0.7h18.8c7.9,0,12.4,3.6,12.4,9.5c0,4.4-3.3,7.7-7.7,8.3v0.3c5.3,0.1,9.5,4,9.5,9.1 c0,6.8-5.3,11.2-13.5,11.2L113.6,39L113.6,39z M124.8,16.1h4.4c2.9,0,4.7-1.5,4.7-3.9s-1.7-3.9-4.6-3.9h-4.6L124.8,16.1 L124.8,16.1z M129.6,31.3c3.5,0,5.5-1.5,5.5-4.4c0-2.8-2.1-4.3-5.4-4.3h-4.8v8.8L129.6,31.3L129.6,31.3z'
  }), _react2.default.createElement('path', {
    fill: '#FFFFFF',
    d: 'M169.9,24.1c0,4,1.9,6.2,5.7,6.2c3.6,0,5.7-2.2,5.7-6.2V0.6h11.3v24.7c0,8.7-6.8,14.4-16.9,14.4 c-10.1,0-16.9-5.5-16.9-14.4V0.7h11.3v23.4H169.9z'
  }), _react2.default.createElement('path', {
    fill: '#FFFFFF',
    d: 'M217.7,39h-11.3V0.7h17c10.2,0,15.5,4.8,15.5,13c0,4.6-2.2,8.8-6.2,10.8l7.3,14.5h-12.6l-6.1-12.9h-3.6V39z M217.7,18.7h4.7c3.2,0,5.1-1.9,5.1-4.8S225.4,9,222.4,9h-4.7V18.7z'
  }), _react2.default.createElement('path', {
    fill: '#FFFFFF',
    d: 'M260.9,27.7c0.3,2.2,3,3.6,5.9,3.6c3.3,0,5.4-1.4,5.4-3.2c0-1.8-1.4-2.5-5.5-3.3l-5.1-1 c-7-1.2-10.9-5.3-10.9-11.3c0-7.7,6.6-12.7,15.8-12.7c10.2,0,15.9,4.7,16,12.2h-10.2c-0.1-2.3-2.5-3.9-5.5-3.9 c-2.9,0-4.8,1.2-4.8,3.2c0,1.8,1.5,2.8,5.3,3.5l5.3,1c7.5,1.2,10.9,4.8,10.9,11.1c0,7.9-6.6,12.9-16.7,12.9 c-10.2,0-16.4-4.3-16.4-12h10.8L260.9,27.7L260.9,27.7z'
  }), _react2.default.createElement('path', {
    fill: '#FFFFFF',
    d: 'M317.9,31.4h-11.7l-1.9,7.6h-11.5l12.6-38.4h14.1L332,39h-12L317.9,31.4z M308.2,23.4h7.6l-3.6-13.8h-0.3 L308.2,23.4z'
  }));
};